// src/utils/AlpineCartRefresher.js

/**
 * Refreshes the cart in Alpine.js. Useful when using the Quick Add to Cart feature.
 */
const AlpineCartRefresher = {
    fetchCart() {
        return fetch('/cart.js')
            .then(res => {
                if (!res.ok) throw new Error('Cart fetch failed');
                return res.json();
            });
    },

    refreshAlpineCart() {
        const Alpine = window.Alpine;
        // your guard:
        if (!Alpine || !Alpine.store || !Alpine.store('cart')) {
            console.warn('Alpine or cart store not ready or wrong hash');
            return;
        }

        const cartStore = Alpine.store('cart');
        cartStore.loading = true;

        // 1) If your theme provided an update() method, use it:
        if (typeof cartStore.update === 'function') {
            cartStore.update();
            cartStore.loading = false;
            return;
        }

        // 2) If there’s an init() method instead, use that:
        if (typeof cartStore.init === 'function') {
            cartStore.init();
            cartStore.loading = false;
            return;
        }

        // 3) Otherwise, fall back to manual fetch + mapping:
        this.fetchCart()
            .then(cartData => {
                Object.assign(cartStore.data, {
                    totalQuantity:    cartData.item_count,
                    items:            cartData.items,
                    subtotalPrice:    cartData.items_subtotal_price,
                });
                cartStore.isEmpty = cartData.item_count === 0;
            })
            .catch(err => {
                console.error('Error refreshing cart:', err);
            })
            .finally(() => {
                cartStore.loading = false;
            });
    }
};

export default AlpineCartRefresher;
export { AlpineCartRefresher };
